import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { OrderDocumentsComponent, OrderDocumentsConfigPartial } from '../order-documents.component';
import { QRCodeUploadPayload } from '../dialog-qr-code-upload/dialog-qr-code-upload.component';
import { PAPER_SCRIPT } from 'app/shared/constants';
import { JwtAuthService } from 'app/shared/services/auth/jwt-auth.service';

export const DEFAULT_PAPER_SCRIPT_TAGS = [PAPER_SCRIPT];

export interface UploadPaperScriptDialogData {
  payload: QRCodeUploadPayload;
  actionButtonConfig?: {
    label: string;
    onClick: () => void;
    show?: boolean;
  };
}

@Component({
    selector: 'app-dialog-upload-paper-script',
    templateUrl: './dialog-upload-paper-script.component.html',
    styleUrls: ['./dialog-upload-paper-script.component.scss'],
    standalone: false
})
export class DialogUploadPaperScriptComponent implements OnInit {
  orderDocumentsConfig: OrderDocumentsConfigPartial = {
    disableTagAutocompleteInUploadDialog: true,
    disableDocumentTitleInUploadDialog: true,
    disableTagAutocompleteInEditDialog: true,
    disableDocumentTitleInEditDialog: true,
    enablePaperScriptsMode: true,
    tagsAutocompleteOptions: {
      removable: false
    },
    // actionMode: 'uploadOnly'
  }
  documentCount = 0;
  defaultTags: string[] = DEFAULT_PAPER_SCRIPT_TAGS;

  @ViewChild(OrderDocumentsComponent) orderDocumentsComponent!: OrderDocumentsComponent;

  constructor(public dialogRef: MatDialogRef<DialogUploadPaperScriptComponent>,
    @Inject(MAT_DIALOG_DATA) public data: UploadPaperScriptDialogData,
    private jwtAuthService: JwtAuthService
  ) { }

  ngOnInit(): void {
    if (this.jwtAuthService.isClinician()) {
      this.orderDocumentsConfig = { ...this.orderDocumentsConfig, enableDocumentUpload: false, autoOpenQRCodeUpload: true, hideEditButton: true };
    }
  }

  close(nextStep: boolean = false): void {
    this.dialogRef.close({ documentCount: this.documentCount, nextStep });
  }

  handleDocumentCountChange(count: number): void {
    this.documentCount = count;
  }
}
